import {colors} from '@xpertdox_js/xdstyle';

export default {
  btn: {
    background: colors.green,
    marginRight: 5
  },
  btnC: {
    background: colors.xdHighlightDark
  },
  btnContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  container: {
    paddingTop: 15,
    borderTop: '1px solid rgba(0, 0, 0, 0.2)',
    margin: '15px 3px 3px 3px',
  }
}
